// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-modules-Integrations-style----wrapper-module---wrapper---hF2EZ breakPointM-alignContent-stretch centered breakPointM-display-flex width-90"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Integrations/style/wrapper.module.css
// module id = 1484
// module chunks = 87034247430840